// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-qstring {
    border: 1px solid #ccc !important;
}

.legend-qstring {
    width: auto !important;
    font-size: 1.1rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/views/data-source/test-datasource/test-datasource.component.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;AAChC","sourcesContent":[".field-qstring {\r\n    border: 1px solid #ccc !important;\r\n}\r\n\r\n.legend-qstring {\r\n    width: auto !important;\r\n    font-size: 1.1rem !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
